import { useSyncExternalStore } from 'react';
import { withFileAuth } from './secureFiles';

// 프로필 사진 목록 { userId: 파일명 } — 접속 시 받고, 누가 바꾸면 실시간으로 갱신된다.
// 메시지 컴포넌트가 사진 하나 바뀌었다고 전부 다시 그려지지 않도록 사용자별로 구독한다.
let avatars = {};
const listeners = new Set();
const emit = () => listeners.forEach(fn => fn());

export const setAvatarMap = (map) => { avatars = { ...(map || {}) }; emit(); };
export const setAvatar = (userId, file) => {
    const next = { ...avatars };
    if (file) next[userId] = file; else delete next[userId];
    avatars = next;
    emit();
};

const subscribe = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };

export const avatarUrlOf = (file) => (file ? withFileAuth(`/api/avatars/${encodeURIComponent(file)}`) : null);

export const useAvatarUrl = (userId) => {
    const file = useSyncExternalStore(subscribe, () => (userId ? avatars[userId] || null : null));
    return avatarUrlOf(file);
};
